import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

export function fetchOrderSkipContent(accessToken: string, orderId: string, orderDate: string) {
  const reqData = orderId
    ? {
        order_date: orderDate,
        order_id: orderId,
      }
    : {
        order_date: orderDate,
      }

  return fetch(accessToken, `${endpoint('orderskiprecovery')}/orderskiprecovery`, reqData, 'GET')
}

export function fetchSubscriptionPauseContent(accessToken: string, enableOffer: boolean) {
  // TODO replace the 1 with subscription id when a) we have access to it, and b) the back end uses it
  return fetch(
    accessToken,
    `${endpoint('subpauseosr', 2)}/subscriptionpauserecovery/1`,
    { enableOffer },
    'GET',
  )
}
